var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import fetch from 'isomorphic-unfetch';
const request = (uri, init) => {
    const host = `https://${window.location.hostname}`;
    return fetch(`${host}${uri}`, init);
};
export const getLinks = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request('/api/products/');
    return yield response.json();
});
export const getTags = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request('/api/tags/');
    return yield response.json();
});
export const getQuestions = (questionId = null) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request(`/api/questions/${questionId}`);
    return yield response.json();
});
export const getMediaElement = (id, type, thumbnail) => `/${type}/el/${id}${thumbnail ? '?thumbnail=true' : ''}`;
export const getLiveVideos = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request('/api/broadcast/live');
    return yield response.json();
});
export const getVideoSeries = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request(`/api/videoseries/${id}`);
    return yield response.json();
});
export const getGuides = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request('/api/guides/');
    return yield response.json();
});
export const getSingleGuide = (guideId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request('/api/guides/' + guideId);
    return yield response.json();
});
export const getPostcards = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request('/api/postcard/' + id);
    const json = yield response.json();
    return json.map((postcard) => {
        return Object.assign(Object.assign({}, postcard), { 'frontSrc': postcard.front ? getMediaElement(postcard.front, 'i') : '', 'backSrc': postcard.back ? getMediaElement(postcard.back, 'i') : '' });
    });
});
export const interactWithFavouritePlaylist = (id, interaction) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request(`/api/playlist/favourites/${interaction}?mediaElementId=${id}`, {
        method: 'POST',
    });
    return yield response.json();
});
export const getCommentsForElement = (type, element) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield request(`/api/comments/${type}/${element}`);
    return yield response.json();
});
export const voteOnComment = (id, reaction) => __awaiter(void 0, void 0, void 0, function* () {
    return yield request(`/api/comments/vote/${id}/${reaction}`)
        .then((res) => res.json());
});
export const setCompanyColor = (type, color) => __awaiter(void 0, void 0, void 0, function* () {
    return yield request(`/api/company/colors/${type}`, {
        method: 'POST',
        body: JSON.stringify(color),
    })
        .then((res) => res.json());
});
/**
 * this allows using FosRoutingBundle Routing in a way, that it supports typescript-ish
 * @param {string} route
 * @param params
 */
export const generateUrl = (route, params = {}) => {
    // @ts-ignore
    return Routing.generate(route, params);
};
